module.exports = "images/categories.30aa5bcd.png";